import React, { useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import userContext from './configs/context/context';
import ErrorBoundary from './components/common/ErrorBoundary';
import { AuthProvider } from './components/common/AuthProvider';
import Layout from './components/common/Layout';
import HomePage from './components/common/page/Homepage/HomePage';
import AboutUs from './components/common/page/AboutUs/AboutUs';
import GalleryPage from './components/common/page/Gallery/GalleryPage';
import ContactUs from './components/common/page/ContactUs/ContactUs';
import ScrollToTop from './components/common/ScrollToTop';
import CateringMenu from './components/common/page/Menus/CustomizedMenu/CateringMenu';
import MenusPage from './components/common/page/Menus/MenusPage';

// import CateringCountdown from './components/component/celebrates/Grandopening';

// Define the UserContextType if not already defined
interface UserContextType {
	user: string;
	setUser: React.Dispatch<React.SetStateAction<string>>;
}

function App() {
	const [user, setUser] = useState<string>('');
	const contextValue: UserContextType = {
		user,
		setUser,
	};
	console.log('contextValue', contextValue);

	return (
		<ErrorBoundary>
			<userContext.Provider value={contextValue}>
				<AuthProvider>
					<BrowserRouter>
						<ScrollToTop />
						<Routes>
							<Route path="/" element={<Layout />}>
								<Route index element={<HomePage />} />
								<Route path="/menu" element={<MenusPage />} />
								<Route path="/about-us" element={<AboutUs />} />
								<Route path="/gallery" element={<GalleryPage />} />
								<Route path="/contactus" element={<ContactUs />} />
								<Route path="/customized-menu" element={<CateringMenu />} />
							</Route>
						</Routes>
					</BrowserRouter>
				</AuthProvider>
			</userContext.Provider>
		</ErrorBoundary>
		// <>
		// 	<BrowserRouter>
		// 		<Routes>
		// 			<Route path="/" element={<CateringCountdown />} />
		// 			<Route path="/menu" element={<MenusPage />} />
		// 		</Routes>
		// 	</BrowserRouter>
		// </>
	);
}

export default App;
